export const IconFacebook = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
<g clip-path="url(#clip0_2087_420)">
  <path d="M12.002 0C5.37094 0 0.00195312 5.36898 0.00195312 12C0.00195312 18.631 5.37094 24 12.002 24C18.633 24 24.002 18.631 24.002 12C24.002 5.36898 18.633 0 12.002 0ZM15.3175 7.3369H13.5635C13.2854 7.3369 12.879 7.48663 12.879 8.08556V9.71123H15.2961L15.018 12.4706H12.879V20.3209H9.62762V12.4706H8.08751V9.71123H9.62762V7.93583C9.62762 6.65241 10.2266 4.6631 12.9003 4.6631H15.2961V7.3369H15.3175Z" fill="white"/>
</g>
<defs>
  <clipPath id="clip0_2087_420">
    <rect width="24" height="24" fill="white" transform="translate(0.00195312)"/>
  </clipPath>
</defs>
</svg>`